export const SampleSidebar = () => (
  <div className="h-screen bg-surface-50 p-2">
    <div className="h-full border-4 border-dashed border-surface-200/50 rounded-lg flex m-auto justify-center items-center">
      <p className="text-black">Sidebar</p>
    </div>
  </div>
)
